import { createStore as reduxCreateStore } from "redux";

const reducer = (state, action) => {
  switch (action.type) {
    case "CHANGE_LANG":
      return {
        ...state,
        lang: action.lang
      };
    case "OPEN_CONTACT_FORM":
      return {
        ...state,
        contactFormOpen: true
      };
    case "CLOSE_CONTACT_FORM":
      return {
        ...state,
        contactFormOpen: false
      };
    case "OPEN_REQUEST_DEMO_FORM":
      return {
        ...state,
        requestDemoFormOpen: true
      };
    case "CLOSE_REQUEST_DEMO_FORM":
      return {
        ...state,
        requestDemoFormOpen: false
      };
    default:
      return state;
  }
};

const initialState = { lang: "en", contactFormOpen: false , requestDemoForm: false};

const createStore = () => {
  return reduxCreateStore(reducer, initialState);
};
export default createStore;



// WEBPACK FOOTER //
// ./src/state/createStore.js